// Utilities
import isEmpty from './isEmpty'
import SessionUtil from './sessionUtil'

class PreferenceUtil {
  static localStorageKey = 'preferencesUtil_'

  static get (key, defaultValue) {
    if (this.canRun()) {
      const pref = this.getInstance()

      return new Promise((resolve, reject) => {
        pref.get(key, defaultValue, resolve, reject)
      })
    } else {
      const value = SessionUtil.getCookie(this.localStorageKey + key)

      if (isEmpty(value)) {
        if (defaultValue === undefined) {
          throw new Error('No preference found using key: ' + key)
        }

        return defaultValue
      }

      return value
    }
  }

  /**
   * Save the passed in preference value. Expiration only applies to browsers.
   */
  static set (key, value, expiration = 999999) {
    if (this.canRun()) {
      const pref = this.getInstance()

      return new Promise((resolve, reject) => {
        pref.put(key, value, resolve, reject)
      })
    } else {
      SessionUtil.setCookie(this.localStorageKey + key, value, expiration)
    }
  }

  static delete (key) {
    if (this.canRun()) {
      const pref = this.getInstance()

      return new Promise((resolve, reject) => {
        pref.del(key, resolve, reject)
      })
    } else {
      SessionUtil.deleteCookie(this.localStorageKey + key)
    }
  }

  static canRun () {
    return window.hasOwnProperty('cordova') && window.hasOwnProperty('plugins') && window.plugins.hasOwnProperty('SharedPreferences')
  }

  static getInstance () {
    return window.plugins.SharedPreferences.getInstance()
  }
}

export default PreferenceUtil
